import script from "./Apps.vue?vue&type=script&setup=true&lang=js"
export * from "./Apps.vue?vue&type=script&setup=true&lang=js"

import "./Apps.vue?vue&type=style&index=0&id=2ef0e49e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ef0e49e"]])

export default __exports__